let allowedMenus = null;
let allowedMenusCode = null;

function getAllowedMenus() {
  return allowedMenus;
}

function setAllowedMenus(menus) {
  allowedMenus = menus;
}

function getAllowedMenusByCode() {
  return allowedMenusCode;
}

function setAllowedMenusByCode(menus) {
  allowedMenusCode = menus;
}

export { getAllowedMenus, setAllowedMenus, getAllowedMenusByCode, setAllowedMenusByCode };
